import "@scss/styles.scss";
import "jquery";
import 'bootstrap';
import files from './file.js';
import gs from './grayscale'